import axios from "axios";
import { API_BASE } from "../config.js";
export default class Auth {

    async register(newUser) {
        return new Promise((resolve, reject) => {
            newUser.deviceType = "Web";
            axios.post(`${API_BASE}/auth/register`, newUser).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                // Pass the server's message along when there is one (e.g. the username is taken)
                let message = error.response && error.response.data && (error.response.data.message || error.response.data.error);
                reject(message ? new Error(message) : error);
            });
        });
    }

    async login(username, password) {
        return new Promise((resolve, reject) => {
            axios.post(`${API_BASE}/auth/login`, {
                username: username,
                password: password,
                deviceType: "Web",
            })
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch(reject);
        });
    }

    // Sign in with the ID token ("credential") from Google's sign-in button. Resolves to { success, token }.
    async googleLogin(credential) {
        return axios.post(`${API_BASE}/auth/google`, { credential, deviceType: "Web" }).then((response) => response.data);
    }

    async logout(userToken) {
        return new Promise((resolve, reject) => {
            axios.post(`${API_BASE}/auth/logout`, { user: userToken, deviceType: "Web" })
            .then(() => {
                resolve();
            })
            .catch((error) => {
                alert(error);
                reject();
            });
        });
    }

    // get userID by token
    async getUserByToken(token) {
        return new Promise((resolve, reject) => {
            axios.get(`${API_BASE}/auth/getID/${token}`)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data.id);
                } else {
                    reject(response.data.message);
                }
            });
        });
    }
    
}
